export const AUTHENTICATION_CODE_LENGTH = 6;
export const VERIFY_EMAIL_PAGE_PAUSE_TIME_AFTER_SUCCESS_VERIFICATION = 3000;
